const readAsArrayBuffer = (file: File): Promise<ArrayBuffer> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result instanceof ArrayBuffer) {
        resolve(reader.result);
      } else {
        reject(new Error('FileReader did not resolve to an ArrayBuffer'));
      }
    };

    reader.onerror = () => reject(reader.error);

    reader.readAsArrayBuffer(file);
  });

/** Base64-encoded SHA-256 digest of a file's bytes, for SEA's document-upload contract. */
const sha256Base64 = async (file: File): Promise<string> => {
  // Reason: `FileReader` (rather than `file.arrayBuffer()`) is what jsdom's `File` implements,
  // so this works the same in real browsers and in tests.
  const buffer = await readAsArrayBuffer(file);
  const digest = await crypto.subtle.digest('SHA-256', buffer);
  return btoa(String.fromCharCode(...new Uint8Array(digest)));
};

export default sha256Base64;
